import type { SignalId } from '@cadstrom/sigma-engine-shared';

/** World-coordinate viewport state saved in selection history entries. */
export interface ViewportState {
	centerX: number;
	centerY: number;
	scale: number;
}

export interface CadRendererSetActiveDesignEventDetail {
	designId?: string;
	instanceId?: string;
	moduleReferenceDesignator?: string;
	net?: string;
	signalId?: SignalId;
	symbolPin?: string;
	footprintPad?: string;
}

export class CadRendererSetActiveDesignEvent extends CustomEvent<CadRendererSetActiveDesignEventDetail> {
	constructor(detail: CadRendererSetActiveDesignEventDetail) {
		super('cadRendererSetActiveDesign', { detail });
	}
}

export interface CadRendererZoomEventDetail {
	moduleReferenceDesignator?: string;
	net?: string;
	signalId?: SignalId;
	symbolPin?: string;
	footprintPad?: string;
}

export class CadRendererZoomEvent extends CustomEvent<CadRendererZoomEventDetail> {
	constructor(detail: CadRendererZoomEventDetail) {
		super('cadRendererZoom', { detail });
	}
}

export interface CadRendererViewportChangedEventDetail {
	revisionId: string;
	viewport: ViewportState;
}

/** Fired immediately whenever the viewport is panned or zoomed. */
export class CadRendererViewportChangedEvent extends CustomEvent<CadRendererViewportChangedEventDetail> {
	constructor(detail: CadRendererViewportChangedEventDetail) {
		super('cadRendererViewportChanged', { detail });
	}
}

/**
 * Dispatches a custom event asynchronously, ensuring it's processed in the next tick
 */
export function dispatchEventAsync(event: CustomEvent): Promise<void> {
	return new Promise((resolve) => {
		dispatchEvent(event);
		setTimeout(resolve, 0);
	});
}

declare global {
	interface WindowEventMap {
		cadRendererSetActiveDesign: CadRendererSetActiveDesignEvent;
		cadRendererZoom: CadRendererZoomEvent;
		cadRendererViewportChanged: CadRendererViewportChangedEvent;
	}
}
